import { attachmentService } from "client-app-core";
import { updateContextProperty } from "orion-components/ContextualData/Actions";
import { getTranslation } from "orion-components/i18n";

export const attachFilesToAlert = (alertId, entityType, files) => {
	return dispatch => {
		dispatch(updateContextProperty(alertId, "uploadError", ""));
		attachmentService.uploadFiles(alertId, "alert", files, (err, result) => {
			if (err) {
				console.log(err);
				switch (err.response.status) {
					case 413:
						dispatch(
							updateContextProperty(
								alertId,
								"uploadError",
								getTranslation(
									"global.sharedActions.fileUploadFailed",
									undefined,
									getTranslation("global.sharedActions.uploadError.maxFileSizeExceeded")
								)
							)
						);
						break;
					default:
						dispatch(
							updateContextProperty(
								alertId,
								"uploadError",
								getTranslation(
									"global.sharedActions.fileUploadFailed",
									undefined,
									getTranslation("global.sharedActions.uploadError.generic")
								)
							)
						);
						break;
				}
			}
			console.log(result);
		});
	};
};
